import { Component, h } from 'preact'

type LazyComponent = () => Promise<typeof Component>

interface LazyRouteProps {
    path?: string
    url?: string
    getComponent: LazyComponent
    loading?: () => h.JSX.Element
    [key: string]: unknown
}

class LazyRoute extends Component<LazyRouteProps> {
    state = {
        componentData: null as typeof Component | null,
    }

    componentDidMount() {
        this.loadComponent()
    }

    componentDidUpdate(prevProps: LazyRouteProps) {
        if (prevProps.path !== this.props.path) {
            this.setState({ componentData: null }, () => this.loadComponent())
        }
    }

    loadComponent() {
        const { getComponent, url } = this.props
        const result = getComponent(url)

        if (result?.then) {
            result.then((component) => {
                if (url === this.props.url) {
                    this.setState({ componentData: component })
                }
            })
        }
    }

    render() {
        const { componentData } = this.state

        if (componentData) {
            return h(componentData, this.props)
        }

        if (this.props.loading) {
            return this.props.loading()
        }

        return null
    }
}

export default LazyRoute
